var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator"},[_c('div',{staticClass:"spinner-container"},[_c('square-loader',{attrs:{"color":"#4E4C67","size":80,"sizeUnit":"px"}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }